module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-700.1aa5d63e.woff";